import React from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/system";
import { primaryTxt } from "../constants/colors";
import mountain from "../assets/mountain.png";

const CenteredSubHeader = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100vw",
  textAlign: "center",
  padding: "5em",
  boxSizing: "border-box",
});

const Text = styled(Typography)(({ theme }) => ({
  fontFamily: "Roboto Slab",
  color: primaryTxt,
  fontWeight: "300",
  padding: "0px 40px",
  marginBottom: "20px",
  [theme.breakpoints.down("sm")]: {
    padding: "0.2em",
  },
}));

const InvertedPng = styled("img")({
  filter: "invert(1)",
  width: "75px",
  height: "75px",
  marginBottom: "50px",
});

export default function Home() {
  return (
    <CenteredSubHeader>
      <InvertedPng src={mountain} />
      <Text variant="h4">
        This private setting is a get-a-way for all, whether you are looking for an adventure or the need to escape. Fantastic for families and outdoor enthusiasts. Located in the small Northern California town of Downieville, it sits on a private lot right on the Downie River. Downtown Downieville is a short 5 minute walk.
      </Text>
    </CenteredSubHeader>
  );
}
